package top.wcpe.allincore.dsl.compiler.semantic.`native`

/**
 * 方法参数个数约束（arity）。
 *
 * 仅约束位置参数总数（含已绑定+待绑定），命名实参/默认值由各方法描述符自行处理。
 */
sealed interface Arity {

    /** 判断给定的位置参数数量是否满足约束。 */
    fun matches(positionalCount: Int): Boolean

    /** 用于诊断渲染的可读描述（如 "2"、"2..3"）。 */
    val displayName: String

    /** 恰好 [n] 个位置参数。 */
    data class Fixed(val n: Int) : Arity {
        init {
            // 不变量：参数个数不能为负
            require(n >= 0) { "Arity.Fixed 参数个数不能为负，实际 n=$n" }
        }

        override fun matches(positionalCount: Int): Boolean = positionalCount == n
        override val displayName: String get() = n.toString()
    }

    /** [min, max] 闭区间内的位置参数数量。 */
    data class Range(val min: Int, val max: Int) : Arity {
        init {
            // 不变量：下界不能为负
            require(min >= 0) { "Arity.Range 下界不能为负，实际 min=$min" }
            // 不变量：下界不能超过上界
            require(min <= max) { "Arity.Range 要求 min <= max，实际 min=$min, max=$max" }
        }

        override fun matches(positionalCount: Int): Boolean =
            positionalCount in min..max

        override val displayName: String get() = "$min..$max"
    }
}
